import classNames from 'classnames';
import React from 'react';

const Panel = (props) => {
  return (
    <div className={ classNames('panel', props.className) }>
      { props.children }
    </div>
  );
};

export default Panel;



// WEBPACK FOOTER //
// ./app/components/shared/panel/_Panel.jsx